import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { Spacer, VStack } from '@/components/Layout';
import { ContractType } from '@/routes/_staff/contract/_list/-constants';

import AddContractGatePrimaryProcedure from './-components/AddContractGatePrimaryProcedure';
import AddContractGateProcedures from './-components/AddContractGateProcedures/index';
import StepperHeader from './-components/StepperHeader';

export const Route = createFileRoute('/_staff/contract/add/')({
  component: Introduce,
});

function Introduce() {
  const [selectedContractType, setSelectedContractType] = useState<
    EnumUnion<typeof ContractType>
  >(ContractType.LEASE);

  return (
    <VStack className="mx-auto w-[1000px]">
      <StepperHeader />
      <Spacer variant="xl" />
      <AddContractGatePrimaryProcedure
        selectedContractType={selectedContractType}
        setSelectedContractType={setSelectedContractType}
      />
      <Spacer variant="m" />
      <AddContractGateProcedures
        selectedContractType={selectedContractType}
        setSelectedContractType={setSelectedContractType}
      />
    </VStack>
  );
}
